// /src/pages/private/admin/academyTabs/courseExam/CourseExamSidebar.jsx

import React from "react";

export default function CourseExamSidebar({ documents = [], activeView, onSelect }) {
  return (
    <nav className="course-exam-sidebar" aria-label="Exam resources">
      <p className="course-exam-sidebar__title">Resources</p>
      <ul className="course-exam-sidebar__list">
        {documents.map((document) => (
          <li key={document.documentName}>
            <button
              type="button"
              className={`course-exam-sidebar__item${
                activeView === document.documentName
                  ? " course-exam-sidebar__item--active"
                  : ""
              }`}
              onClick={() => onSelect(document.documentName)}
            >
              {document.label}
            </button>
          </li>
        ))}
        <li>
          <button
            type="button"
            className={`course-exam-sidebar__item course-exam-sidebar__item--qcm${
              activeView === "qcm" ? " course-exam-sidebar__item--active" : ""
            }`}
            onClick={() => onSelect("qcm")}
          >
            QCM
          </button>
        </li>
      </ul>
    </nav>
  );
}
